import React from 'react';
import { useTranslation } from 'react-i18next';
import WizardChromeV2 from '../../../../../components/WizardV2/WizardChromeV2';
import { getAddAmenityWizardChromeProps } from './addAmenityWizardConfigV2';

function AddAmenityWizardChromeV2({
  stepIndex,
  displayTotalSteps,
  stepName,
  stepDescription,
  stepNotice,
  children
}) {
  const { t } = useTranslation();
  const chromeProps = getAddAmenityWizardChromeProps(stepIndex, t, {
    stepName,
    stepDescription,
    displayTotalSteps
  });

  return (
    <WizardChromeV2 {...chromeProps} stepNotice={stepNotice}>
      {children}
    </WizardChromeV2>
  );
}

export default AddAmenityWizardChromeV2;
